<template>
  <div>
    <div class="completed-courses-section">
      <h6 class="mt-3 mb-0">
        <strong>กรุณาระบุช่วงเวลาที่ต้องการดาวน์โหลดรายงาน</strong>
      </h6>
      <b-row>
        <b-col cols="3">
          <label><strong>ช่วงวันที่จบคอร์สและสอบผ่าน</strong></label>
          <div class="date-range-field">
            <b-input-group>
              <b-form-input
                size="sm"
                type="text"
                :value="formatDate"
                placeholder="เลือกวันที่จบคอร์สและสอบผ่าน"
                disabled
              />
              <b-input-group-prepend>
                <b-button
                  size="sm"
                  variant="secondary"
                  @click="showCalendarRange('calendar-range')"
                >
                  <b-icon icon="calendar-range"></b-icon>
                </b-button>
              </b-input-group-prepend>
            </b-input-group>
            <DatePicker
              v-model="dateRange"
              locale="th"
              id="calendar-range"
              style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
              is-range
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="5">
          <label><strong>เลือกหลักสูตร</strong></label>
          <v-select
            v-if="!isLoadingCourses"
            :options="courseList"
            label="courseName"
            v-model="selectedCourse"
            placeholder="พิมพ์ชื่อคอร์สเรียนที่ต้องการค้นหา"
            :clearable="false"
            @input="displayFilterData()"
          />
          <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
        </b-col>
      </b-row>
      <p class="remark-text">
        หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ .xlsx
        และดาวน์โหลดลงบนเครื่องของคุณ
      </p>

      <b-card class="no-shadow p-3" no-body>
        <div class="table-section">
          <div class="table-header">
            <b-form-input
              class="search-student-info"
              v-model="searchStudentInfo"
              placeholder="ค้นหาข้อมูลผู้เรียน"
            ></b-form-input>
            <b-button
              @click="exportTableReport()"
              id="table-report"
              variant="primary"
              :disabled="filteredDataTable.length < 1"
            >
              <b-icon icon="chevron-double-down" class="mr-1"></b-icon>
              ดาวน์โหลดตารางข้อมูล
              <b-spinner
                id="table-report-loading"
                class="align-middle ml-3 mb-0"
                style="display: none; width: 1.5rem; height: 1.5rem;"
              ></b-spinner>
            </b-button>
            <ag-grid-vue
              style="width: 100%; height: 800px; display: none"
              class="ag-theme-alpine"
              :columnDefs="columnReport"
              @grid-ready="onGridReportReady"
              :rowData="rowReport"
              :excelStyles="excelStyles"
            ></ag-grid-vue>
          </div>

          <b-table
            id="completed-courses-report"
            :fields="fields"
            :items="filteredDataTable"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isTableLoading"
            hover
            show-empty
          >
            <template #empty>
              <p class="text-center py-3">ไม่มีข้อมูล</p>
            </template>
            <template v-slot:cell(complete_date)="props">
              {{ props.item.cer_completeDate | thaiDateFilter }}
            </template>
            <template v-slot:cell(download)="{ item }">
              <div>
                <b-button
                  variant="warning"
                  style="display: inline-block; margin-right: 5px;"
                  v-b-modal="`modal-notify-id-card-${item.m_id}`"
                >
                  <i
                    class="bi bi-envelope-arrow-up-fill"
                    style="color: white"
                  ></i>
                </b-button>

                <b-modal
                  title="ยืนยันการยกเลิกการลงทะเบียน"
                  :id="`modal-notify-id-card-${item.m_id}`"
                  hide-footer
                  hide-header
                  centered
                >
                  <div class="container text-center">
                    <div class="row center-row my-5">
                      <div class="col">
                        <b-icon
                          icon="exclamation-triangle"
                          variant="warning"
                          scale="5"
                        ></b-icon>
                      </div>
                    </div>
                    <div class="row center-row">
                      <div class="col">
                        <label class="bold-text larger-text">
                          แจ้งอัปเดตบัตรประชาชน
                        </label>
                      </div>
                    </div>
                    <div class="row center-row">
                      <div class="col">
                        <label>
                          ส่งอีเมลอัปเดตรูปบัตรประชาชน <br />
                          ให้กับ {{ item.mp_firstName }}
                          {{ item.mp_lastName }} หรือไม่?
                        </label>
                      </div>
                    </div>
                    <div class="row center-row mt-3">
                      <div class="col">
                        <b-button
                          variant="outline-secondary"
                          @click="closeModal(item.m_id)"
                          class="mr-2"
                          :disabled="onNotifying"
                        >
                          ยกเลิก
                        </b-button>
                        <b-button
                          variant="primary"
                          @click="notifyIdCard(item.m_id)"
                          :disabled="onNotifying"
                        >
                          <b-spinner v-if="onNotifying" small></b-spinner>
                          ยืนยัน
                        </b-button>
                      </div>
                    </div>
                  </div>
                </b-modal>

                <b-button
                  target="_blank"
                  id="export-report"
                  variant="primary"
                  style="display: inline-block;"
                  @click="downloadReport(item)"
                >
                  <i class="fa fa-angle-double-down" aria-hidden="true"></i>
                  ดาวน์โหลดรายงาน
                </b-button>
              </div>
            </template>
          </b-table>

          <b-row class="mt-3" v-if="filteredDataTable.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ filteredDataTable.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="filteredDataTable.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="filteredDataTable.length"
                  aria-controls="completed-courses-report"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import vSelect from "vue-select";
import moment from "moment";
import api from "@/services/api";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";

export default {
  mixins: [dateMixin],
  components: { DatePicker, vSelect, "ag-grid-vue": AgGridVue },
  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      token: localStorage.getItem("token"),
      company: this.$store.state.Company.companyInfo,
      dateRange: {
        start: "",
        end: "",
      },
      isLoadingCourses: false,
      courseList: [],
      selectedCourse: null,
      searchStudentInfo: "",
      isTableLoading: false,
      completedCourses: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          label: "เลขที่ใบอนุญาต\nประกันชีวิต",
          key: "life_id",
          thStyle: { whiteSpace: "pre-line" },
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "เลขที่ใบอนุญาต\nประกันวินาศภัย",
          key: "non_life_id",
          thStyle: { whiteSpace: "pre-line" },
          formatter: (value) => {
            return value || "-";
          },
        },
        { label: "ชื่อ", key: "mp_firstName" },
        { label: "นามสกุล", key: "mp_lastName" },
        { label: "ชื่อคอร์ส", key: "c_name" },
        {
          label: "วันที่จบคอร์ส\nและสอบผ่าน",
          key: "complete_date",
          thStyle: { whiteSpace: "pre-line" },
        },
        { label: "", key: "download", class: "text-right" },
      ],
      isShowTable: false,
      onNotifying: false,
      gridApiReport: null,
      columnReport: [
        {
          headerName: "",
          field: "runningNumber",
        },
        { headerName: "", field: "mp_idCard", cellClass: "stringType" },
        {
          headerName: "",
          field: "cpd",
          cellClass: "stringType",
        },
        { headerName: "", field: "sm_cpaNo", cellClass: "stringType" },
        {
          headerName: "",
          field: "mp_prefixName",
        },
        { headerName: "", field: "mp_firstName" },
        { headerName: "", field: "mp_lastName" },
        { headerName: "", field: "c_name" },
        { headerName: "", field: "cer_completeDate" },
      ],
      rowReport: [],
      excelStyles: [
        {
          id: "header",
          font: { fontName: "Cordia New", size: 16, bold: true },
          alignment: {
            horizontal: "Center",
          },
        },
        {
          id: "cell",
          font: { fontName: "Cordia New", size: 16 },
          alignment: {
            horizontal: "Center",
          },
        },
        {
          id: "stringType",
          dataType: "String",
        },
      ],
    };
  },
  computed: {
    filteredDataTable() {
      if (!this.searchStudentInfo) return this.completedCourses;

      return this.completedCourses.filter((item) => {
        const str = this.getFilterString(item);
        return str
          .toLowerCase()
          .replace(/ /g, "")
          .includes(this.searchStudentInfo.toLowerCase().replace(/ /g, ""));
      });
    },
    formatDate() {
      return this.getFormattedRange(
        this.dateRange.start,
        this.dateRange.end,
        "calendar-range",
      );
    },
  },
  async mounted() {
    this.setDefaultDates();
    this.getDataTable();

    await api.get(`v1/companies/${this.comId}/courses`).then(({ data }) => {
      this.courseList = data.data;
      this.isLoadingCourses = false;
    });
  },
  methods: {
    async getDataTable() {
      this.isTableLoading = true;
      let startDate = moment(this.dateRange.start).format("YYYY-MM-DD");
      let endDate = moment(this.dateRange.end).format("YYYY-MM-DD");
      let apiUrl = this.selectedCourse
        ? `/v1/tfac/completed-enroll-report?c_id=${this.selectedCourse.courseId}&complete_date_start=${startDate}&complete_date_finish=${endDate}`
        : `/v1/tfac/completed-enroll-report?complete_date_start=${startDate}&complete_date_finish=${endDate}`;

      await api
        .get(apiUrl)
        .then(({ data }) => {
          this.completedCourses = data;
          this.isTableLoading = false;
        })
        .catch((error) => {
          this.isTableLoading = false;
          console.error("completed-enroll-report: ", error);
          throw error;
        });
    },
    displayFilterData() {
      this.currentPage = 1;
      this.getDataTable();
    },
    exportTableReport() {
      document.getElementById("table-report-loading").style.display =
        "inline-block";
      document.getElementById("table-report").disabled = true;

      let result = this.filteredDataTable;
      let data = [];

      if (result.length > 0) {
        data = result.map((item, index) => {
          return {
            runningNumber: index + 1,
            mp_idCard: item.mp_idCard,
            cpd: item.sm_membershipId,
            sm_cpaNo: item.sm_cpaNo,
            mp_prefixName: "คุณ",
            mp_firstName: item.mp_firstName,
            mp_lastName: item.mp_lastName,
            c_name: item.c_name,
            cer_completeDate: this.thaiDateFilter(item.cer_completeDate),
          };
        });
      }

      let row = [
        ...(this.selectedCourse?.courseName
          ? [
              {
                runningNumber: "ชื่อหลักสูตร",
                mp_idCard: this.selectedCourse.courseName,
              },
            ]
          : []),
        {
          runningNumber: "ช่วงวันที่ : ",
          mp_idCard: this.formatDate,
        },
        { mp_idCard: "" },
        {
          runningNumber: "#",
          mp_idCard: "ID Card",
          cpd: "CPD",
          sm_cpaNo: "CPA",
          mp_prefixName: "Prefix",
          mp_firstName: "First Name",
          mp_lastName: "Last Name",
          c_name: "Course Name",
          cer_completeDate: "Completed",
        },
      ];

      this.rowReport = [...row, ...data];
      setTimeout(() => {
        this.gridApiReport.exportDataAsExcel({
          sheetName: this.generateFileName(),
          fileName: `${this.generateFileName()}`,
        });
        document.getElementById("table-report-loading").style.display = "none";
        document.getElementById("table-report").disabled = false;
      }, 1000);
    },
    generateFileName() {
      let startDate = moment(this.dateRange.start).format("YYYYMMDD");
      let endDate = moment(this.dateRange.end).format("YYYYMMDD");
      let date = startDate == endDate ? startDate : startDate + "-" + endDate;
      let fileName = date;
      fileName += this.selectedCourse
        ? "-(" + this.selectedCourse.courseName + ")"
        : "";
      return fileName;
    },
    async onGridReportReady(params) {
      this.gridApiReport = params.api;
      this.gridColumnApi = params.columnApi;
    },
    downloadReport(item) {
      let url = `${this.company.whitelabelUrl}/courseEnroll/thaireCompletedEnrollReport?cerId=${item.cer_id}&token=${this.token}`;
      window.open(url, "_blank");
    },
    async notifyIdCard(m_id) {
      this.onNotifying = true;
      await api
        .post(`/v1/members/${m_id}/tfac-notify-upload-id-card`)
        .then(() => {
          this.$bvToast.toast(`แจ้งอัปเดตบัตรประชาชนแล้ว`, {
            variant: "success",
            solid: true,
            noCloseButton: true,
          });
          this.onNotifying = false;
          this.closeModal(m_id);
        });
    },
    closeModal(m_id) {
      this.$bvModal.hide(`modal-notify-id-card-${m_id}`);
    },
    getFilterString(item) {
      this.currentPage = 1;

      return (
        item.mp_firstName + item.mp_lastName + item.life_id + item.non_life_id
      );
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.dateRange.start = ninetyDaysAgo.format(dateFormat);
      this.dateRange.end = currentDate.format(dateFormat);
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";
      moment.updateLocale("th", {});
      this.displayFilterData();

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start =
        moment(startDate).format("DD MMM ") + (moment(startDate).year() + 543);
      const end =
        moment(endDate).format("DD MMM ") + (moment(endDate).year() + 543);
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.completed-courses-section {
  display: flex;
  flex-direction: column;
  gap: 40px;

  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .remark-text {
    color: #ffc107;
  }

  .table-section {
    display: flex;
    flex-direction: column;
    gap: 25px;

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;

      .search-student-info {
        width: fit-content;
      }
    }
  }
}

/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
